import App from './app.js';
import * as modules from './modules';



// WEBPACK FOOTER //
// ./_src/js/main.js